// Swiper JS
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import 'swiper/css/bundle';